export default __webpack_public_path__ + "static/media/boyfie.a27c116f.png";